import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { notificationService } from 'src/services/app/notification.service'
import { notifyService } from 'src/services/app/notify.service'
import { storageService } from 'src/services/app/storage.service'
import { NOTIFICATION_TYPES, STORAGE_KEYS } from 'src/services/consts/api.const'
import { NOTIFICATION_MESSAGES } from 'src/services/consts/notification.const'

// Initialize notifications from session storage
const updateNotifications = ref([])
const isDrawerOpen = ref(false)

export function useConfirmUpdate() {
  const router = useRouter()
  const route = useRoute()
  const hasNotifications = computed(() => updateNotifications.value.length > 0)
  const notificationCount = computed(() => updateNotifications.value.length)

  const loadNotificationsFromSession = () => {
    const savedNotifications = storageService.getSession(STORAGE_KEYS.NOTIFICATIONS) || []
    updateNotifications.value = savedNotifications
  }

  const saveNotificationsToSession = () => {
    storageService.setSession(STORAGE_KEYS.NOTIFICATIONS, updateNotifications.value)
  }

  const addUpdateNotification = (notification = {}) => {
    // Check if notification for same company already exists
    const { id, path, updatedBy, updatedAt, assessmentType, isStarting } = notification
    const existingIndex = updateNotifications.value.findIndex((n) => n.id === id)

    if (existingIndex !== -1) {
      // Update existing notification and increment count
      updateNotifications.value[existingIndex] = {
        ...updateNotifications.value[existingIndex],
        count: (updateNotifications.value[existingIndex].count || 1) + 1,
        updatedBy,
        updatedAt,
        assessmentType,
        isStarting,
        path,
      }
    } else {
      // Add new notification at the beginning of the array (most recent first)
      updateNotifications.value.unshift({
        ...notification,
        count: 1,
      })
    }
    if (updateNotifications.value.length > 0) {
      isDrawerOpen.value = true
    }
    saveNotificationsToSession()
  }

  const removeUpdateNotification = (id) => {
    const index = updateNotifications.value.findIndex((n) => n.id === id)
    if (index !== -1) {
      updateNotifications.value.splice(index, 1)
      if (updateNotifications.value.length === 0) {
        isDrawerOpen.value = false
      }
      saveNotificationsToSession()
    }
  }

  const clearAllNotifications = () => {
    updateNotifications.value = []
    isDrawerOpen.value = false
    storageService.removeSession(STORAGE_KEYS.NOTIFICATIONS)
  }

  const setDrawerOpen = (value) => {
    isDrawerOpen.value = value === undefined ? !isDrawerOpen.value : !!value
  }

  const createConfirmAction = (notification) => {
    if (notification.type === NOTIFICATION_TYPES.COMPANY_EDIT) {
      return notificationService.createRefreshAction({
        router,
        route,
        successMessage: NOTIFICATION_MESSAGES.success.refreshCompanyData,
        notification,
      })
    } else if (notification.type === NOTIFICATION_TYPES.PRODUCT_EDIT) {
      return notificationService.createRefreshAction({
        router,
        route,
        successMessage: NOTIFICATION_MESSAGES.success.refreshProductData,
        notification,
      })
    } else if (notification.type === NOTIFICATION_TYPES.AI_ASSESSMENT) {
      return notificationService.createRefreshAction({
        router,
        route,
        successMessage: NOTIFICATION_MESSAGES.success.refreshAiAssessment,
        notification,
      })
    } else {
      return async () => {
        notifyService.error(NOTIFICATION_MESSAGES.error.refreshData)
      }
    }
  }

  return {
    updateNotifications,
    hasNotifications,
    notificationCount,
    isDrawerOpen,
    addUpdateNotification,
    removeUpdateNotification,
    clearAllNotifications,
    setDrawerOpen,
    loadNotificationsFromSession,
    createConfirmAction,
  }
}
